import { IconNameEnum, useModuleBEM } from "@b2bportal/core-themes";
import type { SortOptionEnum } from "@b2bportal/core-types";
import { useI18nContext } from "@hopper-b2b/i18n";
import { FlightListGridFilter, Sort } from "@tenant/flights";
import { Icon } from "@tenant/ui";
import { PackageBreadcrumbs } from "../PackageBreadcrumbs";
import { PackageFlightFilterDialog } from "../PackageFlightFilterDialog";
import { usePackageFlightDeparturePageHeader } from "./hook";
import styles from "./PackageFlightDeparturePageHeader.module.scss";
import { PackagePriceSummary } from "@/pages/Packages/components";
import { CombinedPackageSteps } from "@/pages/Packages/hooks/usePackageFlow";

interface PackageFlightDeparturePageHeaderProps {
  isError: boolean;
  sortOption: SortOptionEnum;
  handleSortChange: (value: SortOptionEnum) => void;
}

export const PackageFlightDeparturePageHeader = ({
  isError,
  sortOption,
  handleSortChange,
}: PackageFlightDeparturePageHeaderProps) => {
  const [block, cn] = useModuleBEM(styles, "PackageFlightDeparturePageHeader");
  const { t } = useI18nContext();
  const { title, routeInfo } = usePackageFlightDeparturePageHeader();
  return (
    <div className={block}>
      <PackageBreadcrumbs
        className={cn("breadcrumbs")}
        currentStep={CombinedPackageSteps.FLIGHT_DEPARTURE}
      />
      <div className={cn("content")}>
        <div className={cn("left-content")}>
          <h1 className={cn("title")}>{title}</h1>

          {routeInfo && (
            <div className={cn("route-info")}>
              <span className={cn("route-airports")}>
                <span className={cn("route-airport")}>{routeInfo.origin} </span>
                <Icon
                  className={cn("route-icon")}
                  iconName={IconNameEnum.rightNavChevron}
                />
                <span className={cn("route-airport")}>
                  {routeInfo.destination}
                </span>
              </span>
              <span className={cn("route-separator")}>•</span>
              <span className={cn("route-date")}>{routeInfo.date}</span>
            </div>
          )}
        </div>
        <div className={cn("right-content")}>
          <PackagePriceSummary />
        </div>
      </div>
      <div className={cn("content")}>
        <div className={cn("left-content")}>
          <p className={cn("trip-category")}>
            <span className={cn("bold")}>{t("flightRoundTrip")}</span>
            {` | ${t("core-flights.flightShopTitle.roundTripSubtitle")}`}
          </p>
        </div>
        <div className={cn("right-content")}>
          {!isError && (
            <div className={cn("controls-row")}>
              <div className={cn("sort-container")}>
                <Sort value={sortOption} handleSortChange={handleSortChange} />
              </div>
              <div className={cn("filters-container")}>
                <PackageFlightFilterDialog sliceIndex={0} />
              </div>
            </div>
          )}
        </div>
      </div>
      <div className={cn("grid-filter-container")}>
        <FlightListGridFilter className={cn("grid-filter")} />
      </div>
    </div>
  );
};
